import { render, staticRenderFns } from "./VolumeTransactionsView.vue?vue&type=template&id=0f57c7a8&scoped=true"
import script from "../js/VolumeTransactions?vue&type=script&lang=js&external"
export * from "../js/VolumeTransactions?vue&type=script&lang=js&external"
import style0 from "./VolumeTransactionsView.vue?vue&type=style&index=0&id=0f57c7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57c7a8",
  null
  
)

export default component.exports